<button mat-raised-button color="primary" bsDaterangepicker [bsConfig]="bsConfig"
        (bsValueChange)="setDate($event)" placement={{placement}} class="col-12">
  <span *ngIf="selectedDate.length !==0">{{selectedDate[0] | date}} - {{selectedDate[1] | date}}
    <mat-icon class="calendar">today</mat-icon>
  </span>
  <span *ngIf="selectedDate.length ==0">Pick a date</span>
  <!--  <fa-icon [icon]="faCalendar"></fa-icon>-->
</button>
